import React from "react";
import ReactTooltip from "react-tooltip";
import { IconButton } from "..";
import { useApp } from "../../_contexts";
import { prefixImgPath } from "../../_helpers";

export function RelatedArticleItem({ article, onClick, isRemovable }) {
  const { editMode } = useApp();
  ReactTooltip.rebuild();
  const classNames = [
    "chronos-related-article",
    `chronos-article-${article.waID}`,
  ];

  const imgPath = article.cover
    ? prefixImgPath(article.cover)
    : "https://www.worldanvil.com/images/placeholder-cyan.jpg";

  const handleRemove = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    console.log("Delete Event Entity", { ...ev });
    if (onClick) onClick(article);
  };

  const handleRead = (ev) => {
    ev.preventDefault();
    if (isRemovable && editMode) {
      return; //Copy link to clipboard and notify/toast?
    }
    const link = document.createElement("a");
    link.href = article.link;
    link.target = "_blank";
    link.click();
    link.remove();
  };

  const tooltipID = article.waID;
  const isWebP = /.webp$/.test(imgPath);
  console.log("IS WEBP?", isWebP);
  // console.log('Article', article);

  return (
    <div
      className={classNames.join(" ")}
      style={{
        backgroundImage: imgPath && !isWebP ? `url(${imgPath})` : "none",
      }}
    >
      {isWebP && (
        <img
          src={imgPath}
          alt={article.title}
          className="chronos-related-article-cover"
        />
      )}
      <div className="chronos-related-article-controls" onClick={handleRead}>
        <h4 className="chronos-related-article-type">{article.type}</h4>
        <p className="chronos-related-article-excerpt">
          {article.excerpt && article.excerpt.length > 0
            ? article.excerpt
            : " "}
        </p>
        <div className="chronos-related-article-options">
          {/* Delete - if editor */}
          {isRemovable && editMode && (
            <IconButton
              iconOnly
              icon="far fa-times fa-fw"
              data-tip="Unlink"
              data-for={tooltipID}
              onClick={handleRemove}
            />
          )}

          {/* Read More - new tab */}
          {/* <IconButton
            iconOnly
            icon="far fa-eye fa-fw"
            data-tip="Read (New Tab)"
            data-for={tooltipID}
            
          /> */}
        </div>
      </div>
      <div className="chronos-article-title">{article.title}</div>
      {/* <div className="chronos-related-article-controls">
        <IconButton
          iconOnly
          icon="far fa-times fa-fw"
          data-tip="Remove"
          data-for={tooltipID}
          onClick={handleRemove}
        />
      </div>
      <div className="chronos-article-image">
        <img src={imgPath} alt={article.title} />
      </div>
      <div className="chronos-article-text">
        <span className="chronos-article-name">{article.title}</span>
      </div> */}
      <ReactTooltip effect="solid" id={tooltipID} />
    </div>
  );
}
